import { ErrorStateScheduleEnum } from '../error-state-schedule.enum';

export enum PanelSettingsMessagingResolverErrorStatesEnum {
    GetMessageTemplatesFailed = ErrorStateScheduleEnum.SettingsMessagingErrorStatesStartIndex,
    GetMessageTemplateByIdFailed,
    UpdateMessageTemplateFailed,
    CreateMessageTemplateFailed,
    GetEmailTemplatesFailed,
    GetEmailTemplateByIdFailed,
    UpdateEmailTemplateFailed,
    CreateEmailTemplateFailed,
    GetClientInfoFailed,
}
